import styled from "styled-components";

export const EnsinioFooterBrandingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  position: relative;
  z-index: 1;

  padding: 3.375rem 1rem;

  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#ffffff" : "#000000"};
  color: ${({ theme }) => theme.console.pageTitleColor};

  svg path {
    fill: ${({ theme }) => theme.console.pageTitleColor};
  }

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }

  .divider {
    width: 1px;
    height: 20px;

    background-color: #393939;
  }
`;
